export const saveUTMTags = () => {
	const UTM_TAGS_NAMES = [ 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content' ];
	
	const queryString = location.search;
	const urlParameters = new URLSearchParams( queryString );
	const UTMTags = {};

	UTM_TAGS_NAMES.forEach( ( it ) => {
		if ( !urlParameters.get( it ) )
		{
			return;
		}

		UTMTags[it] = urlParameters.get( it );
	} );

	if ( !Object.keys( UTMTags ).length )
	{
		return;
	}

	sessionStorage.setItem( 'UTMTags', JSON.stringify( UTMTags ) );
};


//////////////////
// WEBPACK FOOTER
// ./app/Common/UTMTags/index.js
// module id = BAKi
// module chunks = 12